module.exports = __webpack_public_path__ + "static/img/emg-img.172f001e.png";